import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AccountDashboard } from '@components/account/AccountDashboard';
import { LoginOptions } from '@components/auth/LoginOptions';

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  invalid_token: 'This sign-in link is invalid.',
  token_used: 'This sign-in link has already been used.',
  token_expired: 'This sign-in link has expired. Please request a new one.',
  login_failed: 'Sign-in failed. Please try again.',
};

export function AccountPage() {
  const { user, isLoading } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    const error = searchParams.get('auth_error');
    if (error) {
      setAuthError(AUTH_ERROR_MESSAGES[error] || 'An error occurred during sign-in.');
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-20 rounded-lg bg-navy-800" />
        <div className="h-40 rounded-lg bg-navy-800" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="mx-auto max-w-md space-y-6 py-12">
        <div className="glass-card rounded-2xl border border-white/10 p-8 space-y-6">
        <div className="text-center">
          <img src="/images/edg3_labs_logo_light.svg" alt="Edg3 Labs" className="mx-auto h-10 w-auto mb-4" />
          <h1 className="text-2xl font-bold text-white">Welcome Back</h1>
          <p className="mt-2 text-gray-400">Sign in to view your orders and licenses</p>
        </div>
        {authError && (
          <div className="rounded-lg border border-red-500/20 bg-red-500/5 px-4 py-3 text-sm text-red-400">
            {authError}
          </div>
        )}
        <LoginOptions />
        <p className="text-center text-xs text-gray-500">No password needed — we&apos;ll email you a login link.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold text-white">My Account</h1>
      <AccountDashboard />
    </div>
  );
}
